// JobFormFields.tsx
import React, { ChangeEvent } from "react";
import { Col, Row } from "react-bootstrap";
import { UpdateJobData } from "../../types";
import {
  BtnBold,
  BtnBulletList,
  BtnItalic,
  BtnLink,
  BtnStrikeThrough,
  BtnUnderline,
  Editor,
  EditorProvider,
  Toolbar,
  ContentEditableEvent,
} from "react-simple-wysiwyg";

interface JobFormFieldsProps {
  formData: UpdateJobData;
  jobTypes: any[];
  salaryTypes: any[];
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  formatDate: (date: Date | undefined) => string;
  handleEditorChange: (
    field: keyof UpdateJobData,
    event: ContentEditableEvent
  ) => void;
}

const JobFormFields: React.FC<JobFormFieldsProps> = ({
  formData,
  jobTypes,
  salaryTypes,
  handleChange,
  formatDate,
  handleEditorChange,
}) => {
  return (
    <Row>
      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Job Title</label>
          <input
            type="text"
            className="form-control border-dark"
            name="jobTitle"
            value={formData.jobTitle}
            onChange={handleChange}
          />
        </div>
      </Col>
      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Job Location (Select City)</label>
          <select
            className="form-select border-dark"
            name="jobLocation"
            onChange={handleChange}
            value={formData.jobLocation}
          >
            <option value="" disabled>
              Select a location
            </option>
            <option value="Ontario">Ontario</option>
            <option value="Others">Others</option>
          </select>
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Job Type</label>
          <select
            className="form-select border-dark"
            name="jobType"
            onChange={handleChange}
            value={formData.jobType}
          >
            <option value="" disabled>
              Select a job type
            </option>
            {jobTypes &&
              jobTypes
                .filter((type: any) => type.status === 1)
                .map((type: any) => (
                  <option key={type.id} value={type.name}>
                    {type.name}
                  </option>
                ))}
          </select>
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Department</label>
          <input
            type="text"
            className="form-control border-dark"
            name="department"
            onChange={handleChange}
            value={formData.department}
          />
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Industry</label>
          <input
            type="text"
            className="form-control border-dark"
            name="industry"
            onChange={handleChange}
            value={formData.industry}
          />
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Company Name</label>
          <input
            type="text"
            className="form-control border-dark"
            name="companyName"
            onChange={handleChange}
            value={formData.companyName}
          />
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">No of Positon(s)</label>
          <input
            type="number"
            className="form-control border-dark"
            name="numberOfPositions"
            onChange={handleChange}
            value={formData.numberOfPositions}
          />
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">App Url</label>
          <input
            type="text"
            className="form-control border-dark"
            name="appUrl"
            onChange={handleChange}
            value={formData.appUrl}
          />
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Destination</label>
          <select
            className="form-select border-dark"
            name="destination"
            onChange={handleChange}
            value={formData.destination}
          >
            <option defaultValue={""} disabled>
              Select destination
            </option>
            <option value="olade">Olade</option>
            <option value="threesisters">Three Sisters</option>
          </select>
        </div>
      </Col>

      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Opening Date</label>
          <div className="input-group">
            <span className="input-group-text border-dark" id="basic-addon1">
              <i className="bi bi-calendar-plus"></i>
            </span>
            <input
              type="date"
              className="form form-control border-dark"
              name="openDate"
              value={formatDate(formData.openDate)}
              onChange={handleChange}
            />
          </div>
        </div>
      </Col>
      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Closing Date</label>
          <div className="input-group">
            <span className="input-group-text border-dark" id="basic-addon1">
              <i className="bi bi-calendar-plus"></i>
            </span>
            <input
              type="date"
              className="form form-control border-dark"
              name="closeDate"
              value={formatDate(formData.closeDate)}
              onChange={handleChange}
            />
          </div>
        </div>
      </Col>
      <Col md={12} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Job Duties</label>
          <EditorProvider>
            <Editor
              value={formData.jobDescription}
              onChange={(event) => handleEditorChange("jobDescription", event)}
            >
              <Toolbar>
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnStrikeThrough />
                <BtnBulletList />
                <BtnLink />
              </Toolbar>
            </Editor>
          </EditorProvider>
        </div>
      </Col>

      <Col md={12} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Other Info</label>
          <EditorProvider>
            <Editor
              value={formData.otherInfo}
              onChange={(event) => handleEditorChange("otherInfo", event)}
            >
              <Toolbar>
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnStrikeThrough />
                <BtnBulletList />
                <BtnLink />
              </Toolbar>
            </Editor>
          </EditorProvider>
        </div>
      </Col>
      <hr className="border-blend mb-3 mt-3" />
      <h6>Job Salary</h6>
      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Salary Type</label>
          <select
            className="form-select border-dark"
            name="salaryType"
            onChange={handleChange}
            value={formData.salaryType}
          >
            <option value=" " disabled>
              Select a salary type
            </option>
            {salaryTypes &&
              salaryTypes
                .filter((type: any) => type.status === 1)
                .map((type: any) => (
                  <option key={type.id} value={type.name}>
                    {type.name}
                  </option>
                ))}
          </select>
        </div>
      </Col>
      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Salary (min)</label>
          <input
            type="number"
            step="any"
            className="form-control border-dark"
            name="minSalary"
            onChange={handleChange}
            value={formData.minSalary}
          />
        </div>
      </Col>
      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <label className="form-label">Salary (max)</label>
          <input
            type="number"
            step="any"
            className="form-control border-dark"
            name="maxSalary"
            onChange={handleChange}
            value={formData.maxSalary}
          />
        </div>
      </Col>
      <hr className="border-blend mb-3 mt-3" />
      <Col md={4} sm={12}>
        <div className="form-group mb-3">
          <h6>Job Category</h6>
          <select
            className="form-select border-dark"
            name="jobCategory"
            onChange={handleChange}
            value={formData.jobCategory}
          >
            <option value=" " disabled>
              Select job type
            </option>
            <option value="internal">Internal</option>
            <option value="external">External</option>
          </select>
        </div>
      </Col>
    </Row>
  );
};

export default JobFormFields;
